import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingStore } from '../store/loading.store';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingStore = inject(LoadingStore);

  loadingStore.show();

  return next(req).pipe(
    finalize(() => loadingStore.hide())
  );
};
